<template>
    <el-dialog title='学生成绩' :visible.sync="dialogVisible" :close-on-click-modal="false" width="120rem">
        <theory-detail :detail="detail" ref="theory_detail"></theory-detail>
        <div class="btn-box" @click="exportGrade">导出成绩</div>
        <Table :totalSize="pages.total" :pagination="true" :serialNumber="false" :operationWidth="350"
            :currentPage="pages.current" @changeCurrentPage="changeCurrentPage" @changePageSize="changePageSize"
            :pageSize="pages.size" navHeight=40 ref="table" :tableData="tableData" :tableKey="tableKey">
            <template slot="operation" slot-scope="data">
                <el-tooltip class="item" effect="dark" content="重考" placement="top-start">
                    <i class="iconfont icon-reset" @click="makeupTest(data.data.row)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="得分详情" placement="top-start">
                    <i class="iconfont icon-xiangqing" v-if="data.data.row.score!==null" @click="scoreDetail(data.data.row)"></i>
                </el-tooltip>
            </template>
            <template slot="score" slot-scope="data">
                <p>{{ data.data.row.score===null?'未考':'已考' }}</p>
            </template>
        </Table>
    </el-dialog>
</template>

<script>
import { ExaminePaperScorePage, ExaminationReset,GetExaminePaperId,ExamineScoreExport } from '@/api/examine';
import { GetTestPaperQuestion,GetUserAnswerRecord  } from '@/api/paper';
import TheoryDetail from '../../../personCenter/myselfTask/TheoryDetail.vue';
import {download} from '@/utils/utils';
export default {
  components: { TheoryDetail },
    data() {
        return {
            dialogVisible: false,
            tableKey: [],
            pages: {
                current: 1,
                size: 10,
                total: 0
            },
            paperId:'',
            detail:{},
            tableData: [],
            userId:'',
            examineId: '',
            examineName:'',
            tableKey: [
                {
                    name: '用户名称',
                    value: 'userName'
                },
                {
                    name: '班级',
                    value: 'className'
                },
                {
                    name: '得分',
                    value: 'score'
                },
                {
                    name: '考核状态',
                    value: 'score',
                    slot:'score'
                },
                {
                    name: '开始时间',
                    value: 'startTime',
                    width: '200'
                },
                {
                    name: '结束时间',
                    value: 'endTime',
                    width: '200'
                },
                {
                    name: '操作',
                    value: 'operation',
                    slot: 'operation'
                },
            ]
        }
    },
    methods: {
        /**导出成绩 */
        exportGrade(){
            ExamineScoreExport({examineId:this.examineId}).then(res=>{
                download(res.data,this.examineName);
            })
        },
        /**获取学生成绩 */
        examinePaperScorePage() {
            let params = {
                "current": this.pages.current,
                "examineId": this.examineId,
                "size": this.pages.size
            };
            ExaminePaperScorePage(params).then(res => {
                if (res.code == 200) {
                    this.dialogVisible = true;
                    this.tableData = res.data.records;
                    this.tableData.forEach(item=>{
                        for(let key in item){
                            if(item[key]==null&&key!='score'){
                                item[key]='/';
                            }
                        }
                    })
                    this.pages.total = res.data.total;
                }
            })
        },
        /**获取试卷题目数据 */
        getTestPaperQuestion() {
            return new Promise(resolve => {
                var params={
                    "businessId":this.examineId+'-'+this.paperId,
                    "testPaperId":this.paperId,
                    "userId":this.userId,
                    "testPaperRecordId":this.recordId
                }
                GetTestPaperQuestion(params).then(res => {
                    if (res.code == 200) {
                        var questionDetailVOS = res.data.questionDetailVOS;
                        var i = 1;
                        for (let key in questionDetailVOS) {
                            questionDetailVOS[key].orderIndex = i;
                            i++;
                            questionDetailVOS[key] && questionDetailVOS[key].forEach(item => {
                                if (key == '多选题') {
                                    item.value = [];
                                    return;
                                } else if (key == '填空题') {
                                    item.questionOptionVOS && item.questionOptionVOS.forEach(el => {
                                        el.value = '';
                                    })
                                } else {
                                    item.value = '';
                                }
                            })
                        }
                        this.detail = res.data;
                        let dialog=this.$refs.theory_detail;
                        if(dialog){
                            dialog.dialogVisible=true;
                        }
                        resolve(res.data);
                    }
                })
            })
        },
         /**通过考核id获取理论试卷(组合) */
         getExaminePaperId(){
            return new Promise((resolve)=>{
                GetExaminePaperId({id:this.examineId}).then(res=>{
                    if(res.code==200){
                        resolve(res.data);
                    }
                })
            })
        },
        /**获取用户答题记录 */
        getUserAnswerRecord() {
            return new Promise(resolve=>{
                var params = {
                "businessId": this.examineId+'-'+this.paperId,
                "testPaperId": this.paperId,
                "userId":this.userId,
                "testPaperSource": 'examine_paper'
                }
                GetUserAnswerRecord(params).then(async(res) => {
                    if (res.code == 200) {
                        this.recordId=res.data.id;
                        await this.getTestPaperQuestion(this.examineId);
                        this.$set(this.detail,'userQuestionScoreVOS',res.data.userQuestionScoreVOS);
                        let startTime=new Date(res.data.startTime).getTime();
                        let endTime=new Date(res.data.endTime).getTime();
                        let userTestTime=(endTime-startTime)/1000;
                        this.$set(this.detail,'userTestTime',userTestTime);
                        let questionDetailVOS = this.detail.questionDetailVOS;
                        res.data.userQuestionScoreVOS && res.data.userQuestionScoreVOS.forEach(item => {
                            var data = questionDetailVOS[item.questionType];
                            var userAnswer = item.userAnswer || [];
                            if (data) {
                                let e = data.find(el => el.questionId == item.questionId);
                                if (e) {
                                    this.$set(e, 'correctAnswer', item.correctAnswer || []);
                                    this.$set(e, 'score', item.score || 0);
                                    this.$set(e, 'content', item.content || '暂无');
                                    var questionType = item.questionType;
                                    if (questionType == '多选题') {
                                        e.value = userAnswer;
                                    } else if (questionType == '填空题') {
                                        e.questionOptionVOS.forEach((a, b) => {
                                            a.value = userAnswer[b] ? userAnswer[b] : '';
                                        })
                                    } else {
                                        e.value = userAnswer[0] ? userAnswer[0] : '';
                                    }
                                }
                            }
                        })
                        resolve(res.data);
                    }
                })
            })
        },
        /**得分详情 */
        scoreDetail(data){
            this.userId=data.userId;
            let dialog=this.$refs.theory_detail;
            if(dialog){
                this.getExaminePaperId().then((paperId)=>{
                    this.paperId=paperId;
                    this.getUserAnswerRecord();
                })
            }
        },
        /**补考 */
        makeupTest(data) {
            this.$confirm('是否确认重置考试?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    "examineId": this.examineId,
                    "userId": data.userId
                }
                ExaminationReset(params).then(res => {
                    if (res.code == 200) {
                        this.$msg({
                            showClose: true,
                            message: "重置考试成功",
                            type: "success",
                        });
                        this.examinePaperScorePage();
                    }
                })
            });
        },
        changeCurrentPage(e) {
            this.pages.current = e;
            this.examinePaperScorePage();
        },
        changePageSize(e) {
            this.pages.size = e;
            this.pages.current = 1;
            this.examinePaperScorePage();
        }
    }
}
</script>

<style lang="less" scoped>
/deep/.el-dialog__title {
    font-size: 16px;
    font-weight: 700;
}

/deep/.el-dialog {
    border-radius: 16px;
}
/deep/.el-dialog__body{
    padding: 1rem 3rem 2rem 3rem !important;
}
.icon-reset{
    color: var(--blue);
    cursor: pointer;
    font-size: 1.8rem;
}
.icon-xiangqing{
    color: var(--blue);
    cursor: pointer;
    margin-left: 2rem;
    font-size: 16px;
}
.btn-box {
    width: 12rem;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e8ecef;
    border-radius: 10px;
    color: #ffffff;
    transition: all 0.3s;
    cursor: pointer;
    background-color: var(--blue);
    margin-bottom: 2rem;
}
</style>